module.exports = __webpack_public_path__ + "img/facts-foodandbeverage.242a8725.svg";